// ============================================================
// Extra National Teams — nations that did NOT make the 32-team
// World Cup. Combined with WC_NATIONS_DATA they give ~220+ nations.
// Each entry uses light-weight defs (name, flag, country, teamOvr)
// — rosters are auto-generated via buildNationalTeam(def, []).
// ============================================================

export const OTHER_NATIONS_DATA = [
  // === Europe (UEFA tier 2) ===
  { name: 'Scotland',        flag: '🏴󠁧󠁢󠁳󠁣󠁴󠁿', country: 'Scotland',        teamOvr: 76 },
  { name: 'Wales',           flag: '🏴󠁧󠁢󠁷󠁬󠁳󠁿', country: 'Wales',           teamOvr: 75 },
  { name: 'Northern Ireland',flag: '🇮🇪', country: 'Northern Ireland',teamOvr: 70 },
  { name: 'Republic of Ireland', flag: '🇮🇪', country: 'Ireland',     teamOvr: 73 },
  { name: 'Ukraine',         flag: '🇺🇦', country: 'Ukraine',         teamOvr: 78 },
  { name: 'Sweden',          flag: '🇸🇪', country: 'Sweden',          teamOvr: 77 },
  { name: 'Norway',          flag: '🇳🇴', country: 'Norway',          teamOvr: 80 },
  { name: 'Finland',         flag: '🇫🇮', country: 'Finland',         teamOvr: 71 },
  { name: 'Iceland',         flag: '🇮🇸', country: 'Iceland',         teamOvr: 70 },
  { name: 'Denmark',         flag: '🇩🇰', country: 'Denmark',         teamOvr: 82 },
  { name: 'Austria',         flag: '🇦🇹', country: 'Austria',         teamOvr: 79 },
  { name: 'Czech Republic',  flag: '🇨🇿', country: 'Czechia',         teamOvr: 76 },
  { name: 'Slovakia',        flag: '🇸🇰', country: 'Slovakia',        teamOvr: 73 },
  { name: 'Hungary',         flag: '🇭🇺', country: 'Hungary',         teamOvr: 75 },
  { name: 'Romania',         flag: '🇷🇴', country: 'Romania',         teamOvr: 73 },
  { name: 'Bulgaria',        flag: '🇧🇬', country: 'Bulgaria',        teamOvr: 70 },
  { name: 'Greece',          flag: '🇬🇷', country: 'Greece',          teamOvr: 74 },
  { name: 'Albania',         flag: '🇦🇱', country: 'Albania',         teamOvr: 72 },
  { name: 'Serbia',          flag: '🇷🇸', country: 'Serbia',          teamOvr: 80 },
  { name: 'Croatia',         flag: '🇭🇷', country: 'Croatia',         teamOvr: 82 },
  { name: 'Slovenia',        flag: '🇸🇮', country: 'Slovenia',        teamOvr: 72 },
  { name: 'Bosnia & Herzegovina', flag: '🇧🇦', country: 'Bosnia',     teamOvr: 73 },
  { name: 'North Macedonia', flag: '🇲🇰', country: 'N Macedonia',     teamOvr: 71 },
  { name: 'Montenegro',      flag: '🇲🇪', country: 'Montenegro',      teamOvr: 70 },
  { name: 'Kosovo',          flag: '🇽🇰', country: 'Kosovo',          teamOvr: 69 },
  { name: 'Belarus',         flag: '🇧🇾', country: 'Belarus',         teamOvr: 68 },
  { name: 'Russia',          flag: '🇷🇺', country: 'Russia',          teamOvr: 78 },
  { name: 'Moldova',         flag: '🇲🇩', country: 'Moldova',         teamOvr: 66 },
  { name: 'Estonia',         flag: '🇪🇪', country: 'Estonia',         teamOvr: 65 },
  { name: 'Latvia',          flag: '🇱🇻', country: 'Latvia',          teamOvr: 65 },
  { name: 'Lithuania',       flag: '🇱🇹', country: 'Lithuania',       teamOvr: 65 },
  { name: 'Luxembourg',      flag: '🇱🇺', country: 'Luxembourg',      teamOvr: 64 },
  { name: 'Malta',           flag: '🇲🇹', country: 'Malta',           teamOvr: 60 },
  { name: 'Cyprus',          flag: '🇨🇾', country: 'Cyprus',          teamOvr: 64 },
  { name: 'Andorra',         flag: '🇦🇩', country: 'Andorra',         teamOvr: 56 },
  { name: 'San Marino',      flag: '🇸🇲', country: 'San Marino',      teamOvr: 50 },
  { name: 'Liechtenstein',   flag: '🇱🇮', country: 'Liechtenstein',   teamOvr: 55 },
  { name: 'Gibraltar',       flag: '🇬🇮', country: 'Gibraltar',       teamOvr: 56 },
  { name: 'Faroe Islands',   flag: '🇫🇴', country: 'Faroe Islands',   teamOvr: 62 },
  { name: 'Armenia',         flag: '🇦🇲', country: 'Armenia',         teamOvr: 67 },
  { name: 'Azerbaijan',      flag: '🇦🇿', country: 'Azerbaijan',      teamOvr: 67 },
  { name: 'Georgia',         flag: '🇬🇪', country: 'Georgia',         teamOvr: 73 },
  { name: 'Israel',          flag: '🇮🇱', country: 'Israel',          teamOvr: 72 },
  { name: 'Kazakhstan',      flag: '🇰🇿', country: 'Kazakhstan',      teamOvr: 67 },
  { name: 'Turkey',          flag: '🇹🇷', country: 'Turkey',          teamOvr: 80 },

  // === South America (CONMEBOL non-WC) ===
  { name: 'Chile',           flag: '🇨🇱', country: 'Chile',           teamOvr: 76 },
  { name: 'Paraguay',        flag: '🇵🇾', country: 'Paraguay',        teamOvr: 72 },
  { name: 'Bolivia',         flag: '🇧🇴', country: 'Bolivia',         teamOvr: 67 },
  { name: 'Venezuela',       flag: '🇻🇪', country: 'Venezuela',       teamOvr: 70 },
  { name: 'Peru',            flag: '🇵🇪', country: 'Peru',            teamOvr: 74 },
  { name: 'Uruguay',         flag: '🇺🇾', country: 'Uruguay',         teamOvr: 82 },
  { name: 'Colombia',        flag: '🇨🇴', country: 'Colombia',        teamOvr: 82 },
  { name: 'Ecuador',         flag: '🇪🇨', country: 'Ecuador',         teamOvr: 75 },

  // === CONCACAF / North & Central America / Caribbean ===
  { name: 'Mexico',          flag: '🇲🇽', country: 'Mexico',          teamOvr: 79 },
  { name: 'USA',             flag: '🇺🇸', country: 'United States',   teamOvr: 79 },
  { name: 'Canada',          flag: '🇨🇦', country: 'Canada',          teamOvr: 76 },
  { name: 'Costa Rica',      flag: '🇨🇷', country: 'Costa Rica',      teamOvr: 71 },
  { name: 'Panama',          flag: '🇵🇦', country: 'Panama',          teamOvr: 70 },
  { name: 'Honduras',        flag: '🇭🇳', country: 'Honduras',        teamOvr: 68 },
  { name: 'Guatemala',       flag: '🇬🇹', country: 'Guatemala',       teamOvr: 66 },
  { name: 'El Salvador',     flag: '🇸🇻', country: 'El Salvador',     teamOvr: 65 },
  { name: 'Nicaragua',       flag: '🇳🇮', country: 'Nicaragua',       teamOvr: 60 },
  { name: 'Belize',          flag: '🇧🇿', country: 'Belize',          teamOvr: 56 },
  { name: 'Jamaica',         flag: '🇯🇲', country: 'Jamaica',         teamOvr: 70 },
  { name: 'Cuba',            flag: '🇨🇺', country: 'Cuba',            teamOvr: 63 },
  { name: 'Haiti',           flag: '🇭🇹', country: 'Haiti',           teamOvr: 65 },
  { name: 'Dominican Republic', flag: '🇩🇴', country: 'Dominican Rep', teamOvr: 60 },
  { name: 'Trinidad & Tobago', flag: '🇹🇹', country: 'Trinidad',      teamOvr: 65 },
  { name: 'Curacao',         flag: '🇨🇼', country: 'Curacao',         teamOvr: 64 },
  { name: 'Suriname',        flag: '🇸🇷', country: 'Suriname',        teamOvr: 62 },
  { name: 'Guyana',          flag: '🇬🇾', country: 'Guyana',          teamOvr: 58 },
  { name: 'Barbados',        flag: '🇧🇧', country: 'Barbados',        teamOvr: 56 },
  { name: 'Bahamas',         flag: '🇧🇸', country: 'Bahamas',         teamOvr: 52 },
  { name: 'Bermuda',         flag: '🇧🇲', country: 'Bermuda',         teamOvr: 55 },
  { name: 'Grenada',         flag: '🇬🇩', country: 'Grenada',         teamOvr: 54 },
  { name: 'St Lucia',        flag: '🇱🇨', country: 'St Lucia',        teamOvr: 52 },
  { name: 'St Kitts & Nevis',flag: '🇰🇳', country: 'St Kitts',        teamOvr: 50 },
  { name: 'Antigua & Barbuda',flag:'🇦🇬', country: 'Antigua',         teamOvr: 52 },
  { name: 'Dominica',        flag: '🇩🇲', country: 'Dominica',        teamOvr: 50 },
  { name: 'Cayman Islands',  flag: '🇰🇾', country: 'Cayman',          teamOvr: 48 },
  { name: 'Puerto Rico',     flag: '🇵🇷', country: 'Puerto Rico',     teamOvr: 58 },

  // === Africa (CAF) ===
  { name: 'Senegal',         flag: '🇸🇳', country: 'Senegal',         teamOvr: 81 },
  { name: 'Morocco',         flag: '🇲🇦', country: 'Morocco',         teamOvr: 82 },
  { name: 'Algeria',         flag: '🇩🇿', country: 'Algeria',         teamOvr: 78 },
  { name: 'Tunisia',         flag: '🇹🇳', country: 'Tunisia',         teamOvr: 75 },
  { name: 'Egypt',           flag: '🇪🇬', country: 'Egypt',           teamOvr: 79 },
  { name: 'Libya',           flag: '🇱🇾', country: 'Libya',           teamOvr: 65 },
  { name: 'Cameroon',        flag: '🇨🇲', country: 'Cameroon',        teamOvr: 76 },
  { name: 'Nigeria',         flag: '🇳🇬', country: 'Nigeria',         teamOvr: 80 },
  { name: 'Ghana',           flag: '🇬🇭', country: 'Ghana',           teamOvr: 76 },
  { name: 'Ivory Coast',     flag: '🇨🇮', country: 'Ivory Coast',     teamOvr: 79 },
  { name: 'Mali',            flag: '🇲🇱', country: 'Mali',            teamOvr: 74 },
  { name: 'Burkina Faso',    flag: '🇧🇫', country: 'Burkina Faso',    teamOvr: 72 },
  { name: 'Guinea',          flag: '🇬🇳', country: 'Guinea',          teamOvr: 73 },
  { name: 'Guinea-Bissau',   flag: '🇬🇼', country: 'Guinea-Bissau',   teamOvr: 67 },
  { name: 'Sierra Leone',    flag: '🇸🇱', country: 'Sierra Leone',    teamOvr: 65 },
  { name: 'Liberia',         flag: '🇱🇷', country: 'Liberia',         teamOvr: 64 },
  { name: 'Cape Verde',      flag: '🇨🇻', country: 'Cape Verde',      teamOvr: 71 },
  { name: 'Gambia',          flag: '🇬🇲', country: 'Gambia',          teamOvr: 68 },
  { name: 'Mauritania',      flag: '🇲🇷', country: 'Mauritania',      teamOvr: 66 },
  { name: 'Senegal',         flag: '🇸🇳', country: 'Senegal B',       teamOvr: 70 },
  { name: 'Togo',            flag: '🇹🇬', country: 'Togo',            teamOvr: 66 },
  { name: 'Benin',           flag: '🇧🇯', country: 'Benin',           teamOvr: 68 },
  { name: 'Niger',           flag: '🇳🇪', country: 'Niger',           teamOvr: 64 },
  { name: 'Chad',            flag: '🇹🇩', country: 'Chad',            teamOvr: 60 },
  { name: 'CAR',             flag: '🇨🇫', country: 'CAR',             teamOvr: 58 },
  { name: 'Equatorial Guinea',flag:'🇬🇶', country: 'Eq Guinea',       teamOvr: 67 },
  { name: 'Gabon',           flag: '🇬🇦', country: 'Gabon',           teamOvr: 70 },
  { name: 'Congo',           flag: '🇨🇬', country: 'Congo',           teamOvr: 67 },
  { name: 'DR Congo',        flag: '🇨🇩', country: 'DR Congo',        teamOvr: 73 },
  { name: 'Angola',          flag: '🇦🇴', country: 'Angola',          teamOvr: 70 },
  { name: 'Zambia',          flag: '🇿🇲', country: 'Zambia',          teamOvr: 71 },
  { name: 'Zimbabwe',        flag: '🇿🇼', country: 'Zimbabwe',        teamOvr: 68 },
  { name: 'Malawi',          flag: '🇲🇼', country: 'Malawi',          teamOvr: 64 },
  { name: 'Mozambique',      flag: '🇲🇿', country: 'Mozambique',      teamOvr: 67 },
  { name: 'Botswana',        flag: '🇧🇼', country: 'Botswana',        teamOvr: 63 },
  { name: 'Namibia',          flag:'🇳🇦', country: 'Namibia',         teamOvr: 65 },
  { name: 'Lesotho',         flag: '🇱🇸', country: 'Lesotho',         teamOvr: 60 },
  { name: 'Eswatini',        flag: '🇸🇿', country: 'Eswatini',        teamOvr: 58 },
  { name: 'South Africa',    flag: '🇿🇦', country: 'South Africa',    teamOvr: 75 },
  { name: 'Madagascar',      flag: '🇲🇬', country: 'Madagascar',      teamOvr: 65 },
  { name: 'Mauritius',       flag: '🇲🇺', country: 'Mauritius',       teamOvr: 58 },
  { name: 'Seychelles',      flag: '🇸🇨', country: 'Seychelles',      teamOvr: 50 },
  { name: 'Comoros',         flag: '🇰🇲', country: 'Comoros',         teamOvr: 62 },
  { name: 'Sudan',           flag: '🇸🇩', country: 'Sudan',           teamOvr: 65 },
  { name: 'South Sudan',     flag: '🇸🇸', country: 'South Sudan',     teamOvr: 58 },
  { name: 'Ethiopia',        flag: '🇪🇹', country: 'Ethiopia',        teamOvr: 65 },
  { name: 'Eritrea',         flag: '🇪🇷', country: 'Eritrea',         teamOvr: 58 },
  { name: 'Djibouti',        flag: '🇩🇯', country: 'Djibouti',        teamOvr: 55 },
  { name: 'Somalia',         flag: '🇸🇴', country: 'Somalia',         teamOvr: 55 },
  { name: 'Kenya',           flag: '🇰🇪', country: 'Kenya',           teamOvr: 68 },
  { name: 'Uganda',          flag: '🇺🇬', country: 'Uganda',          teamOvr: 67 },
  { name: 'Tanzania',        flag: '🇹🇿', country: 'Tanzania',        teamOvr: 66 },
  { name: 'Rwanda',          flag: '🇷🇼', country: 'Rwanda',          teamOvr: 63 },
  { name: 'Burundi',         flag: '🇧🇮', country: 'Burundi',         teamOvr: 60 },
  { name: 'São Tomé & Príncipe', flag:'🇸🇹', country: 'Sao Tome',     teamOvr: 50 },

  // === Asia (AFC) ===
  { name: 'South Korea',     flag: '🇰🇷', country: 'South Korea',     teamOvr: 80 },
  { name: 'Japan',           flag: '🇯🇵', country: 'Japan',           teamOvr: 82 },
  { name: 'Australia',       flag: '🇦🇺', country: 'Australia',       teamOvr: 76 },
  { name: 'Saudi Arabia',    flag: '🇸🇦', country: 'Saudi Arabia',    teamOvr: 74 },
  { name: 'Iran',            flag: '🇮🇷', country: 'Iran',            teamOvr: 78 },
  { name: 'Iraq',            flag: '🇮🇶', country: 'Iraq',            teamOvr: 72 },
  { name: 'Qatar',           flag: '🇶🇦', country: 'Qatar',           teamOvr: 74 },
  { name: 'UAE',             flag: '🇦🇪', country: 'UAE',             teamOvr: 72 },
  { name: 'Bahrain',         flag: '🇧🇭', country: 'Bahrain',         teamOvr: 68 },
  { name: 'Oman',            flag: '🇴🇲', country: 'Oman',            teamOvr: 70 },
  { name: 'Kuwait',          flag: '🇰🇼', country: 'Kuwait',          teamOvr: 68 },
  { name: 'Yemen',           flag: '🇾🇪', country: 'Yemen',           teamOvr: 60 },
  { name: 'Jordan',          flag: '🇯🇴', country: 'Jordan',          teamOvr: 71 },
  { name: 'Lebanon',         flag: '🇱🇧', country: 'Lebanon',         teamOvr: 67 },
  { name: 'Syria',           flag: '🇸🇾', country: 'Syria',           teamOvr: 69 },
  { name: 'Palestine',       flag: '🇵🇸', country: 'Palestine',       teamOvr: 67 },
  { name: 'Afghanistan',     flag: '🇦🇫', country: 'Afghanistan',     teamOvr: 58 },
  { name: 'Pakistan',        flag: '🇵🇰', country: 'Pakistan',        teamOvr: 56 },
  { name: 'India',           flag: '🇮🇳', country: 'India',           teamOvr: 65 },
  { name: 'Bangladesh',      flag: '🇧🇩', country: 'Bangladesh',      teamOvr: 55 },
  { name: 'Nepal',           flag: '🇳🇵', country: 'Nepal',           teamOvr: 54 },
  { name: 'Bhutan',          flag: '🇧🇹', country: 'Bhutan',          teamOvr: 48 },
  { name: 'Sri Lanka',       flag: '🇱🇰', country: 'Sri Lanka',       teamOvr: 54 },
  { name: 'Maldives',        flag: '🇲🇻', country: 'Maldives',        teamOvr: 56 },
  { name: 'Myanmar',         flag: '🇲🇲', country: 'Myanmar',         teamOvr: 58 },
  { name: 'Thailand',        flag: '🇹🇭', country: 'Thailand',        teamOvr: 68 },
  { name: 'Vietnam',         flag: '🇻🇳', country: 'Vietnam',         teamOvr: 68 },
  { name: 'Cambodia',        flag: '🇰🇭', country: 'Cambodia',        teamOvr: 56 },
  { name: 'Laos',            flag: '🇱🇦', country: 'Laos',            teamOvr: 54 },
  { name: 'Malaysia',        flag: '🇲🇾', country: 'Malaysia',        teamOvr: 64 },
  { name: 'Singapore',       flag: '🇸🇬', country: 'Singapore',       teamOvr: 62 },
  { name: 'Indonesia',       flag: '🇮🇩', country: 'Indonesia',       teamOvr: 65 },
  { name: 'Philippines',     flag: '🇵🇭', country: 'Philippines',     teamOvr: 62 },
  { name: 'Brunei',          flag: '🇧🇳', country: 'Brunei',          teamOvr: 50 },
  { name: 'Timor-Leste',     flag: '🇹🇱', country: 'Timor-Leste',     teamOvr: 54 },
  { name: 'China',           flag: '🇨🇳', country: 'China',           teamOvr: 70 },
  { name: 'Hong Kong',       flag: '🇭🇰', country: 'Hong Kong',       teamOvr: 60 },
  { name: 'Macau',           flag: '🇲🇴', country: 'Macau',           teamOvr: 48 },
  { name: 'Chinese Taipei',  flag: '🇹🇼', country: 'Chinese Taipei',  teamOvr: 56 },
  { name: 'Mongolia',        flag: '🇲🇳', country: 'Mongolia',        teamOvr: 50 },
  { name: 'North Korea',     flag: '🇰🇵', country: 'North Korea',     teamOvr: 65 },
  { name: 'Kyrgyzstan',      flag: '🇰🇬', country: 'Kyrgyzstan',      teamOvr: 64 },
  { name: 'Tajikistan',      flag: '🇹🇯', country: 'Tajikistan',      teamOvr: 65 },
  { name: 'Turkmenistan',    flag: '🇹🇲', country: 'Turkmenistan',    teamOvr: 60 },
  { name: 'Uzbekistan',      flag: '🇺🇿', country: 'Uzbekistan',      teamOvr: 72 },

  // === Oceania (OFC) ===
  { name: 'New Zealand',     flag: '🇳🇿', country: 'New Zealand',     teamOvr: 70 },
  { name: 'Fiji',            flag: '🇫🇯', country: 'Fiji',            teamOvr: 60 },
  { name: 'Papua New Guinea',flag: '🇵🇬', country: 'PNG',             teamOvr: 56 },
  { name: 'Solomon Islands', flag: '🇸🇧', country: 'Solomon Is',      teamOvr: 58 },
  { name: 'New Caledonia',   flag: '🇳🇨', country: 'New Caledonia',   teamOvr: 62 },
  { name: 'Tahiti',          flag: '🇵🇫', country: 'Tahiti',          teamOvr: 60 },
  { name: 'Vanuatu',         flag: '🇻🇺', country: 'Vanuatu',         teamOvr: 54 },
  { name: 'Samoa',           flag: '🇼🇸', country: 'Samoa',           teamOvr: 48 },
  { name: 'American Samoa',  flag: '🇦🇸', country: 'American Samoa',  teamOvr: 40 },
  { name: 'Tonga',           flag: '🇹🇴', country: 'Tonga',           teamOvr: 46 },
  { name: 'Cook Islands',    flag: '🇨🇰', country: 'Cook Islands',    teamOvr: 48 },
];
